var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "url(#paint0_linear_1604_8501)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M78.8461 49.5652L51.1682 21.888C48.4732 19.2766 44.537 17.7998 40.0089 17.7998C31.8177 17.7998 25.041 22.5544 25.041 31.5148L35.4052 41.879C34.7263 43.3768 34.2962 45.2486 34.2962 47.6784V48.8203L37.3089 51.8329H34.057V62.2009L50.4695 78.6128C57.3585 76.7384 63.6215 73.0574 68.6105 67.9504C73.5995 62.8434 77.1333 56.4961 78.8461 49.5652Z",
    fill: "url(#paint1_linear_1604_8501)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2962 47.6784C34.2962 40.8606 37.6722 38.4185 40.4762 36.3876C42.4833 34.9636 44.1652 33.7457 44.1652 31.3169C44.1652 28.7656 42.2487 27.16 39.9741 27.16C37.6743 27.16 35.525 28.696 35.525 31.5148H25.041C25.041 22.5548 31.8177 17.7998 40.0089 17.7998C48.5325 17.7998 54.9581 23.0326 54.9581 31.2148C54.9581 36.9059 51.7797 39.3641 48.9527 41.5656C46.7068 43.2966 44.7266 44.8224 44.7266 47.6776V48.8195H34.2962V47.6784ZM34.0562 51.8329H44.8813V62.2009H34.0564L34.0562 51.8329Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1604_8501",
    x1: 0,
    y1: 40,
    x2: 80,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1604_8501",
    x1: 25.6308,
    y1: 25.0619,
    x2: 68.5668,
    y2: 67.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/Question_Mark.dfced0a5e4364656ccc913a5c4213341.svg";
export { ForwardRef as ReactComponent };